import { Row, Col } from "antd";
import AddClientForm from "components/form/Client/Add";
import { useFetchLocalStorage } from "lib/useFetchLocalStorage";
import useUser from "lib/useUser";

function AddClient() {
  useFetchLocalStorage();
  useUser({ redirectTo: "/login" });

  return (
    <Row gutter={[16, 16]}>
      <Col xs={24} md={10}>
        <div className="info">
          <h3>Client Detail</h3>
          <p>Please fill in all new information to add new client.</p>
        </div>
      </Col>
      <Col xs={24} md={14}>
        <AddClientForm />
      </Col>
    </Row>
  );
}

export default AddClient;
